import { CopyIcon, ClipboardIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Button, Flex, Tooltip } from "antd";
import { useIsMac } from "hooks/useIsMac/";
import { useIsMobile } from "hooks/useIsMobile/";

export const CopyPaste = ({
  onCopy,
  onPaste,
  canCopy,
  canPaste,
}: {
  onCopy: () => void;
  onPaste: () => void;
  canCopy: boolean;
  canPaste: boolean;
}) => {
  const t = useTranslate();
  const isMac = useIsMac();
  const { isMobile } = useIsMobile();
  const controlKey = isMac ? "⌘" : "Ctrl";
  const copyKey = isMobile ? "" : ` (${controlKey}+C)`;
  const pasteKey = isMobile ? "" : ` (${controlKey}+V)`;

  return (
    <Flex>
      <Tooltip
        title={t("components.templates.settings.copyItem", {
          key: copyKey,
        })}
      >
        <Button
          icon={<CopyIcon size={20} />}
          type="text"
          onClick={onCopy}
          disabled={!canCopy}
        />
      </Tooltip>
      <Tooltip
        title={t("components.templates.settings.pasteItem", {
          key: pasteKey,
        })}
      >
        <Button
          icon={<ClipboardIcon size={20} />}
          type="text"
          onClick={onPaste}
          disabled={!canPaste}
        />
      </Tooltip>
    </Flex>
  );
};
